import { isPlatformHost } from '@/lib/platformHost';

/**
 * O app admin instalável (PWA) e os sites públicos dos tenants saem do
 * mesmo build/origem — um registro incondicional do service worker (como o
 * script que o VitePWA injeta por padrão) aplica o app-shell cacheado
 * também aos sites públicos, substituindo o HTML por-página que o Worker de
 * roteamento monta em navegações repetidas, e quebra especificamente o
 * Safari (recusa responder navegação com uma Response de service worker que
 * carregue `redirected: true`, herdado do precache do index.html).
 *
 * Só registra no app admin (host da plataforma, fora de `/s/*`); em
 * qualquer outra página, desregistra e limpa os caches — auto-cura
 * visitantes que já tinham instalado o service worker antes deste fix,
 * sem precisar de nenhuma ação manual da parte deles.
 */
export function setupServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const isAdminApp = isPlatformHost() && !window.location.pathname.startsWith('/s/');
    if (isAdminApp) {
      void import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true }));
      return;
    }
    void cleanupServiceWorker();
  });
}

async function cleanupServiceWorker() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }
}
